<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div scheduling class="notification headerColor" v-if="formData">
      <div class="pb-3" v-if="(mailingCommunicationID || communicationID) <= 0">
        <b-notification type="is-info is-light" has-icon aria-close-label="Close notification">
          <div>
            Please save General Information Prior to attaching an Attachment
          </div>
        </b-notification>
      </div>
      <div v-else>
        <div class="box is-12">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(onFormSubmit)" class="form">
                <fieldset>
                  <div>
                    <div class="force-center subtitle pb-5">
                      Email Attachment Documents
                    </div>

                    <div v-if="!hasReadonly" class="column is-12">
                      <section class="pt-6 violation-image-upload">
                        <b-field class="file">
                          <b-upload
                            v-model="files"
                            multiple
                            drag-drop
                            accept="application/pdf"
                            class="rectangle"
                          >
                            <section class="force-center float-center">
                              <div class="force-center float-center">
                                <div class="force-center float-center" style="padding-left: 166px">
                                  <img
                                    class="Fill-1-Copy-11 force-center float-center"
                                    src="@/assets/images/fill-1-copy-11.svg"
                                    alt="Upload"
                                  />
                                </div>
                                <div class="force-center float-center">
                                  <div class="Drag-Drop-your-fil">
                                    <div class="text-style-1">Drag & Drop</div>
                                    <div class="force-center float-center">
                                      Drop your PDF files here or click to upload.
                                    </div>
                                    <div class="force-center float-center">
                                      Select one or more files from your computer.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </b-upload>
                        </b-field>

                        <ul id="gallery" class="flex flex-1 flex-wrap -m-1">
                          <li
                            v-show="previews !== undefined && !previews.length"
                            class="h-full w-full text-center flex flex-col items-center justify-center items-center"
                          >
                            <img
                              class="mx-auto w-32"
                              src="https://user-images.githubusercontent.com/507615/54591670-ac0a0180-4a65-11e9-846c-e55ffce0fe7b.png"
                              alt="no data"
                            />
                            <span class="text-small text-gray-500">No files selected</span>
                          </li>
                          <li
                            v-for="(image, index) in previews"
                            :key="index"
                            class="p-1 flex w-1/4 h-32"
                          >
                            <div
                              class="align-items-center relative w-full h-full bg-cover"
                              :style="`background-image: url(${image});`"
                            >
                              <button
                                class="delete is-small"
                                type="button"
                                @click="deleteDropFile(index)"
                              />
                              <label
                                class="absolute inset-x-0 bottom-0 bg-black bg-opacity-50 z-10 p-2"
                              >
                                <span style="color:white;">{{ files[index].name }}</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </section>
                    </div>
                    <span>
                      <figure
                        v-for="(doc, dindex) in documents"
                        :key="dindex"
                        vio-photo
                        tabindex="0"
                        :aria-label="'photo ' + (dindex + 1)"
                        :style="{
                          position: 'relative',
                          display: 'inline-flex',
                          justifyContent: 'center',
                          alignItems: 'center',

                          margin: '4px',

                          height: '140px',
                          width: '140px',

                          overflow: 'hidden',
                          borderRadius: '6px',

                          boxShadow: '0 12px 18px 0 rgba(0, 0, 0, 0.25)'
                        }"
                        @click.prevent="openPDFModal(doc.id)"
                      >
                        <transition name="fade">
                          <PDFTile
                            v-if="documents[dindex] && documents[dindex].content"
                            :src="documents[dindex].content"
                            :style="{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translateX(-50%) translateY(-50%)',
                              flexShrink: '0',
                              maxWidth: '100%',
                              maxHeight: '100%',
                              height: '100%',
                              width: '100%',
                              objectFit: 'contain',

                              cursor: 'pointer'
                            }"
                          />
                        </transition>
                      </figure>
                    </span>

                    <PDFModal ref="pdfModal" />

                    <div v-if="!hasReadonly">
                      <b-button type="is-primary" @click.prevent="saveAttachments"
                        >Add Attachment(s)</b-button
                      >&nbsp;&nbsp;&nbsp;
                      <b-button type="is-primary" @click.prevent="deleteConfirmation"
                        >Delete Attachments</b-button
                      >
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'
import PDFModal from '@/components/Modals/PDF'
import PDFTile from '@/components/tiles/PDF'

export default {
  name: 'AttachmentsCommunication',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly,
    PDFModal,
    PDFTile
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingType',
        'mailingTypeID',
        'emailMessage',
        'emailMessageSubject',
        'mailingCommunicationID',
        'communicationDescription',
        'selectedDeliveryOwnerIDs',
        'selectedDeliveryOwners',
        'deliveryDate',
        'isFullDuplex',
        'isColor',
        'hasReadonly'
      ])
    })
  },

  mounted() {
    this.reload()
  },

  watch: {
    hoaId() {
      this.reload()
    },
    files() {
      this.updateAttachments()
      //this.getAttachments()
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        communicationAttachmentUpdate: { title: 'Save Communication Attachments' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}
</style>
